import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import TextInput from "@/components/inputs/TextInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldLabelText',
  props: {
	form: {
		type: Object,
	},
    value: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: 'Field Label',
    },
    placeholder: {
        type: String,
        default: 'Field Label',
    },
    id: {
        type: String,
        default: 'field_label',
    },
    name: {
        type: String,
        default: 'field_label',
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;
const form = ref<object>(props.form);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TextInput, {
      type: "text",
      label: __props.label,
      placeholder: __props.placeholder,
      id: __props.id,
      name: __props.name,
      disabled: __props.disabled
    }, null, 8, ["label", "placeholder", "id", "name", "disabled"])
  ]))
}
}

})